import MyApplicationQueries from "../../../jsx/components/Dashboard/MyApplications/myapplicationqueries";

const MyApplicationQueriesWrapper = () => {
  return <MyApplicationQueries />;
};

export default constore(MyApplicationQueriesWrapper);
